import React from 'react';
import { Button, Menu, MenuItem, Typography } from '@material-ui/core';
import { ExitToApp, Person, CompareArrows, AccountBox } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

function GroupMenu2(props) {

  //console.log(props);
  const intl = props.intl;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  //console.log(props);
  //{ resetSession },

  const MenuItemConst = (item) => (
    <MenuItem onClick={handleClose}>
      <AccountBalanceIcon /> <span style={{ marginLeft: '10px' }}>{ item }</span>
    </MenuItem>
  )

  return (
  
    <div style={{display: 'inline'}}>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <Typography variant="h6">
        <div style={{paddingLeft: '30px',color:"#fff", fontSize:'20px'}}>
          <strong>{props.group.groupName}</strong>
        </div>
        </Typography>
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        { props.group.OrgList.map((item, key) => {
          return MenuItemConst(item);
        })}
       
      </Menu>
    </div>
  );
}

GroupMenu2.propTypes = {
  group: PropTypes.object.isRequired,
};


export default GroupMenu2;
